import type { FC } from "react";

import styled from "styled-components";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

const CIRCLE_CLASS = "circle-loader";
const CIRCLE_DIAMETER = "30px";
const AXIS_WIDTH = 5;

const Container = styled.div`
    opacity: 0.8;
    padding: 0px 32px;
    width: calc(100% - 48px);
    height: 465px;
    position: relative;
    .${CIRCLE_CLASS} {
        border-radius: 50%;
    }
`;

const AbsoluteCircleContainer = styled.div<{ left: string; bottom: string }>`
    position: absolute;
    ${({ left, bottom }) => `
        left: ${left};
        bottom: ${bottom};
    `}
`;

const AbsoluteCircle: FC<{ diameter: string; left: string; bottom: string }> = (props) => {
    const { diameter, bottom, left } = props;
    return (
        <AbsoluteCircleContainer
            left={left}
            bottom={bottom}
        >
            <PixelPlaceholderLoader
                width={diameter}
                height={diameter}
                className={CIRCLE_CLASS}
            />
        </AbsoluteCircleContainer>
    );
};

const YaxisContainer = styled.div`
    position: relative;
    bottom: -48px;
    height: 100%;
`;
const Yaxis = () => {
    return (
        <YaxisContainer>
            <PixelPlaceholderLoader
                width={AXIS_WIDTH}
                height={"95%"}
            />
        </YaxisContainer>
    );
};
export const KeywordGroupsScatterPlotLoadingSkeleton = () => {
    return (
        <Container>
            <Yaxis />
            <PixelPlaceholderLoader
                width={"100%"}
                height={AXIS_WIDTH}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER}
                left={"15%"}
                bottom={"30px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER}
                left={"25%"}
                bottom={"180px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER}
                left={"35%"}
                bottom={"100px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER}
                left={"55%"}
                bottom={"260px"}
            />
            <AbsoluteCircle
                diameter={CIRCLE_DIAMETER}
                left={"70%"}
                bottom={"120px"}
            />
        </Container>
    );
};
